<template>
  <q-tray
    class="modal-guest-tray"
    v-model="modal"
    :onButtonPressed="handleModalGuest"
    :onClose="handleModalGuest"
    :noButton="true"
  >
    <q-padder v-if="viewState === 'default'" vertical="sm" class="container">
      <form @submit.prevent="handleModalGuest" id="searchResultGuest">
        <q-text variant="ui-baseline" ink="label" bold center>{{ content.QoalaOnlineCarDetail.guestTitle }}!</q-text>
        <q-spacer bottom="xs" />
        <q-padder vertical="xxs">
          <q-row style="justify-content: space-between;">
            <q-padder bottom="xxs">
              <q-text variant="ui-small" ink="label" bold>{{ content.QoalaOnlineCarDetail.fullNameLabel }}</q-text>
            </q-padder>
            <q-padder bottom="xxs" right="xxs">
              <q-text variant="ui-small" ink="muted" style="textAlign:right">{{
                content.QoalaOnlineCarDetail.fullNameDesc
              }}</q-text>
            </q-padder>
          </q-row>
          <q-input
            v-model="userGuest.fullName"
            :placeholder="content.QoalaOnlineCarDetail.fullNameLabel"
            @input="handleFullname"
            variant="formal"
            :border="true"
            fontVariant="ui-small"
            ink="primary"
            style="borderRadius:10px;"
          />
        </q-padder>
        <q-padder vertical="xxs">
          <q-padder bottom="xxs">
            <q-text variant="ui-small" ink="label" bold>{{ content.QoalaOnlineCarDetail.phoneNumberLabel }}</q-text>
          </q-padder>
          <q-input
            @focus="focused = true"
            v-model="userGuest.phone"
            :on-addition-click="showListCountry"
            :image-field="flagCountry"
            :border="true"
            :addition-field="true"
            :formal-padding="true"
            :addition-field-value="computedCountry.phoneCode"
            variant="formal"
            placeholder="800000000"
            type="tel"
            font-variant="ui-small"
            @input="updatePhone"
            style="borderRadius:10px;"
            maxlength="13"
          />
        </q-padder>
        <q-padder vertical="xxs">
          <q-padder bottom="xxs">
            <q-text variant="ui-small" ink="label" bold>{{ content.QoalaOnlineCarDetail.emailLabel }}</q-text>
          </q-padder>
          <q-input
            v-model="userGuest.email"
            :placeholder="content.QoalaOnlineCarDetail.emailLabel"
            variant="formal"
            :border="true"
            fontVariant="ui-small"
            ink="primary"
            style="borderRadius:10px"
            @blur="validateInput('email')"
          />
        </q-padder>
        <q-spacer top="sm" />
        <div>
          <q-button :class="validateForm ? 'btnSuccess' : 'btnError'">
            {{ content.QoalaOnlineCarDetail.doneButtonLabel }}
          </q-button>
        </div>
      </form>
    </q-padder>
    <transition name="slide-fade" mode="out-in">
      <input-list-search-selection
        v-if="viewState === 'selectCountry'"
        class="list__container"
        @update-country="updateCountry"
      />
    </transition>
  </q-tray>
</template>

<script>
import {
  Card as QCard,
  Input as QInput,
  Padder as QPadder,
  Spacer as QSpacer,
  Button as QButton,
  Text as QText,
  Column as QColumn,
  Grid as QGrid,
  Row as QRow,
  Skeleton as QSkeleton,
  Tray as QTray
} from '@qoala/ui';

// import InputPhoneNumber from ''
import InputPhoneNumber from '@/components/input/InputPhoneNumber';
import listCountry from '@/static/data/countryList.json';
import ArrowDownLite from '@/assets/icons/ArrowDownLight';
import InputListSearchSelection from '@/components/input/InputListSearchSelection.vue';

export default {
  components: {
    QCard,
    QPadder,
    QButton,
    QSpacer,
    QText,
    QGrid,
    QRow,
    QColumn,
    QSkeleton,
    QTray,
    QInput,
    InputPhoneNumber,
    ArrowDownLite,
    InputListSearchSelection
  },
  data() {
    return {
      modal: false,
      focused: false,
      viewState: 'default',
      userGuest: {
        fullName: '',
        phone: '',
        email: ''
      },
      countryChoosen: {
        name: 'Indonesia',
        countryCode: 'ID',
        phoneCode: '+62'
      },
      valid: true,
      tempData: {}
    };
  },
  created() {},
  computed: {
    computedCountry() {
      if (this.countryChoosen.countryCode === '' || this.countryChoosen.name === '') {
        const codeByIP = this.$store.getters['general/getCountryCode'];
        const countryFind = listCountry.find(country => country.countryCode === codeByIP);
        if (countryFind) return countryFind;
        return this.countryChoosen;
      }
      return this.countryChoosen;
    },
    flagCountry() {
      if (this.computedCountry.name.length > 0) {
        return `/images/icons/flags/${this.computedCountry.name.replace(/ /g, '_')}.png`;
      }
      return this.computedCountry.name;
    },
    validateForm() {
      if (
        this.userGuest.fullName !== '' &&
        this.userGuest.phone !== '' &&
        this.userGuest.email !== '' &&
        this.userGuest.phone.length > 8 &&
        this.$helper.validateEmail(this.userGuest.email)
      ) {
        return true;
      }
      return false;
    }
  },
  props: {
    data: {
      type: Array
    },
    content: {
      type: Object
    },
    productType: {
      type: String,
      required: false
    }
  },
  methods: {
    handleFullname() {
      this.userGuest.fullName = this.userGuest.fullName.replace(/[^a-zA-Z ]/g, '');
    },
    validateInput(type) {
      if (type === 'email') {
        if (!this.$helper.validateEmail(this.userGuest.email)) {
          this.$toasted.error(this.$t('invalidEmailFormat'), {
            duration: 3000,
            fullWidth: true,
            closeOnSwipe: true
          });
        }
      }
    },
    showModal() {
      this.modal = !this.modal;
    },
    handleModalGuest() {
      if (this.validateForm) {
        this.tempData.phone = this.countryChoosen;
        this.tempData.guest = this.userGuest;
        this.modal = true;
        this.$analytics.pushEvent({
          event: 'Search-Result-Guest',
          eventCategory: this.productType,
          eventLabel: 'Search-Result-Guest-Click-Submit-Success'
        });
        this.$analytics.pushEvent({
          eventCategory: this.productType,
          eventLabel: `${this.productType}, ${this.tempData.guest.fullName}, ${this.tempData.guest.phone}, ${this.tempData.guest.email}`
        });
      }
      this.$emit('handleModalGuest', { data: this.tempData });
    },
    showListCountry() {
      this.viewState = 'selectCountry';
    },
    updatePhone() {
      this.userGuest.phone = this.userGuest.phone.replace(/\D/g, '');
      let phoneNumber = this.userGuest.phone;
      if (phoneNumber.charAt(0) === '0') phoneNumber = phoneNumber.substr(1);
    },
    updateCountry(data) {
      this.countryChoosen = data;
      this.viewState = 'default';
    }
  }
};
</script>

<style lang="scss">
@import '~/assets/css/mixins.scss';
.modal-guest-tray {
  .tray-controller {
    border-bottom: none;
    padding: 0;
  }
  .tray-inner-content {
    padding-top: 0px;
  }
  @include orangeInput(900);
  .tray-footer {
    padding: 8px 16px;
  }
  .btnSuccess {
    @include clearBtn;
    background-color: #f87300 !important;
  }
  .btnError {
    @include clearBtn;
    background-color: grey !important;
  }
}
</style>
